import {memo} from 'react';
import NailArtwork from './NailArtwork.jsx';
import {PATTERNS,DECORATIONS} from './design-model.js';
import {PHOTO_DECORATIONS} from './photo-catalog.js';
import {Icon} from './StudioShared.jsx';
import './canvas-layer-panel.css';

export const FRENCH_LAYER_ID='__french__';
export function canvasLayerName(layer){
 return layer.id===FRENCH_LAYER_ID?'法式':layer.kind==='stroke'?'手绘笔触':layer.kind==='sticker'?'自定义贴纸':layer.kind==='pattern'?(PATTERNS.find(p=>p.id===layer.type)?.name||'图案'):([...PHOTO_DECORATIONS,...DECORATIONS].find(d=>d.id===layer.type)?.name||'饰品');
}
const Thumbnail=memo(function Thumbnail({design,nail,layer}){
 const french=layer.id===FRENCH_LAYER_ID;
 const preview={...nail,color:'pearl-white',customColor:'#e5ded8',opacity:1,finish:'glossy',gradient:{enabled:false},catEye:{enabled:false},french:french?nail.french:{enabled:false},layers:french?[]:[{...layer,visible:true,opacity:1,...(['charm','sticker'].includes(layer.kind)?{x:50,y:75,scale:1}: {})}]};
 return <span className="canvas-layer-thumbnail" aria-hidden="true"><NailArtwork nail={preview} shape={design.shape} shapeVariant={design.shapeVariant} length={design.length} assets={design.assets}/></span>;
});
export default function CanvasLayerPanel({design,active,selectedLayer,onSelectLayer,onDone}){
 const nail=design.nails[active],layers=[...nail.layers].reverse();
 if(nail.french?.enabled||nail.finish==='french')layers.push({id:FRENCH_LAYER_ID,kind:'french'});
 return <aside className="canvas-layer-panel" data-layer-actions="true" aria-label="当前甲片图层" onPointerDown={e=>e.stopPropagation()} onClick={e=>e.stopPropagation()}>
  <header><strong>图层</strong><button type="button" onClick={onDone}>完成</button></header>
  <div className="canvas-layer-list">
   {layers.map((layer,index)=><button type="button" className="canvas-layer-row" data-canvas-layer={layer.id} key={layer.id} aria-pressed={selectedLayer===layer.id} onClick={()=>onSelectLayer(layer.id)}>
    <Thumbnail design={design} nail={nail} layer={layer}/><span><b>{canvasLayerName(layer)}</b><small>{layer.id===FRENCH_LAYER_ID?'甲面工艺':`第 ${nail.layers.length-index} 层`}{layer.visible===false&&<span> · 已隐藏</span>}</small></span>
    {selectedLayer===layer.id&&<Icon name="check" size={12}/>}
   </button>)}
   {!layers.length&&<p className="canvas-layer-empty">这枚甲片还没有图层。</p>}
  </div>
 </aside>;
}
